import { http } from '@/http'

export default {
  list(employeeId, dependentId) {
    return http.get(`/employee-documents/employee/${employeeId}`, { params: dependentId ? { dependentId } : {} })
  },
  // Documentos archivados del colaborador (status 0, sin dependientes), del más reciente al más antiguo
  listArchived(employeeId) {
    return http.get(`/employee-documents/employee/${employeeId}/archived`)
  },
  get(id)          { return http.get(`/employee-documents/${id}`) },
  upload(formData) { return http.post('/employee-documents/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) },
  // includeArchived: permite descargar documentos archivados (el archivo se conserva al archivar)
  download(id, includeArchived = false) {
    return http.get(`/employee-documents/${id}/download`, { responseType: 'blob', params: includeArchived ? { includeArchived: true } : {} })
  },
  delete(id)       { return http.delete(`/employee-documents/${id}`) },
}
